import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {Observable} from 'rxjs';
import {FirestoreService} from '../../../services/firestore.service';

@Component({
    selector: 'site-footer',
    templateUrl: './site-footer.component.html',
    styleUrl: './site-footer.component.scss',
    standalone: false
})
export class SiteFooterComponent {
	page: string;
  navBar$: Observable<Object>;
  navBar: Iterable<any> = [];

	constructor(
		private route: ActivatedRoute,
		private router: Router,
    	private firestoreService: FirestoreService
	) {
		this.page = this.router.url;
    this.navBar$ = this.firestoreService.getSiteNav('navBar');
    this.navBar$.subscribe((value: any) => { this.navBar = value });
	}

	navigate(url: string) {
		 this.router.navigate([url]);
	}
}
